import script from "./PageFiltersOutlet.vue?vue&type=script&lang=js"
export * from "./PageFiltersOutlet.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__